<template>
  <div>
    <v-card color="cardbackground">
      <v-card-title class="pt-2">
        User Role
      </v-card-title>
      <v-card-text>
        <v-btn
          block
          color="primary"
          :disabled="!isOnline || disabled"
          @click="openMainDialog()">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          Open Editor
        </v-btn>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="showMainDialog"
      max-width="800px"
      transition="dialog-bottom-transition"
      persistent>
      <v-card flat color="cardbackground">
        <v-card-text class="pa-4">
          <egg-dialog-title
            title="User Role"
            subtitle="Editor"
            @close-clicked="closeMainDialog()"
          />
          <v-card flat>
            <v-card-text class="pa-4">
              <v-card class="py-1 px-4 mb-2">
                <v-data-table
                  fixed-header
                  :search="search"
                  :headers="lookupItemHeaders"
                  :items="lookupItems"
                  no-data-text="No Data Available">
                  <template v-slot:top>
                    <div class="mb-0 d-flex flex-wrap overflow-y-auto">
                      <v-text-field
                        class="mt-1"
                        v-model="search"
                        clearable
                        label="Search"
                        type="text"
                        prepend-icon="mdi-magnify"
                      />
                      <egg-action-buttons
                        class="mt-2 ml-4"
                        primary-button-icon="mdi-plus"
                        @primary-button-clicked="addItem()"
                        primary-button-text="Add"
                        show-large-buttons
                      />
                    </div>
                  </template>
                  <template v-slot:[`item.isEnabled`]="{ item }">
                    <div class="d-flex justify-center">
                      <v-icon v-if="item.isEnabled">mdi-checkbox-marked-outline</v-icon>
                      <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </div>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <egg-action-buttons
                      primary-button-icon="mdi-square-edit-outline"
                      @primary-button-clicked="editItem(item)"
                      secondary-button-icon="mdi-trash-can-outline"
                      @secondary-button-clicked="confirmDeleteItem(item)" />
                  </template>
                </v-data-table>
              </v-card>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-form ref="form" v-model="validForm">
      <v-dialog v-model="showChangeDialog" 
        scrollable 
        persistent
        max-width="600px">
        <v-card>
          <v-card-title class="text-h5">
             {{isAdd ? 'Add' : 'Edit'}} User Role
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editedItem.userPrincipalName"
                  label="User Email"
                  :disabled="!isAdd"
                  hint="e.g. john.doe@cobbvantress.com"
                  :rules="[rules.required, isEmailValidRule]" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="editedItem.contextName"
                  label="Role"
                  :items="['USER', 'MANAGER', {text:'ADMIN', disabled:true}]"
                  :rules="[rules.required]" />
              </v-col>
              <v-col cols="12" sm="6">
              <v-select
                v-model="editedItem.contextValue"
                :disabled="editedItem.contextName == 'ADMIN'"
                label="Farms"
                :items="farms"
                :rules="[rules.requiredMultiselect]"
                multiple
              />
              </v-col>
            </v-row>
          </v-card-text>
          <egg-card-actions
            primary-button-text="Save"
            secondary-button-text="Cancel"
            :disabled="!validForm"
            @primary-button-clicked="saveItem()"
            @secondary-button-clicked="closeChangeDialog()" />
        </v-card>
      </v-dialog>
      <v-dialog v-model="showDeleteDialog" persistent max-width="350">
        <v-card>
          <v-card-title class="text-h5">
            Confirm Delete
          </v-card-title>
          <v-card-text>
             Ok to Delete '{{itemToDelete.userPrincipalName}}'?
          </v-card-text>
          <egg-card-actions
            primary-button-text="Yes"
            secondary-button-text="No"
            @primary-button-clicked="deleteItem()"
            @secondary-button-clicked="showDeleteDialog = false" />
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import DialogTitle from './DialogTitle'
import ActionButtons from './ActionButtons'
import CardActions from './CardActions'
import eggApi from '../api/eggApi'
import { mapState } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
  },
  created() {
    this.rules = { ...this.$root.validationRules };
  },
  components: {
    'egg-dialog-title': DialogTitle,
    'egg-action-buttons': ActionButtons,
    'egg-card-actions': CardActions
  },
  data() {
    return {
      lookupItems: [],
      editedItem: {},
      itemToDelete: {},
      isAdd: false,
      rules: null,
      search: '',
      showDeleteDialog: false,
      showChangeDialog: false,
      showMainDialog: false,
      validForm: true
    }
  },
  computed: {
    ...mapState(['settings','isOnline']),
    farms() {
      return this.settings.farms.map(x=> x.farmCode);
    },
    lookupItemHeaders() {
      return [
        { text: 'User Account', value: 'userPrincipalName', sortable: true, align: 'center' },
        { text: 'Role', value: 'contextName', sortable: true, align: 'center' },
        { text: 'Farms', value: 'contextValue', sortable: true, align: 'center' },
        { text: 'Actions', value: 'action', sortable: false, align: 'center' }
      ];
    }
  },
  methods: {
    addItem() {
      this.$refs.form.resetValidation();
      this.isAdd = true;
      this.editedItem = {
      };
      this.showChangeDialog = true;
    },
    closeChangeDialog() {
      this.showChangeDialog = false;
    },
    closeMainDialog() {
      this.showMainDialog = false;
    },
    confirmDeleteItem(item) {
      this.itemToDelete = item;
      this.showDeleteDialog = true;
    },
    async deleteItem() {
      await eggApi.deleteAccount(this.itemToDelete.userPrincipalName);
      this.lookupItems = await eggApi.getUserAccounts();
      this.showDeleteDialog = false;
    },
    editItem(item) {
      this.$refs.form.resetValidation();
      this.isAdd = false;
      this.editedItem = {
        userPrincipalName: item.userPrincipalName,
        contextName: item.contextName,
        contextValue: item.contextValue?.split(',')
      }
      this.showChangeDialog = true;
    },
    // isRoleValidRule(v)
    // {
    //   if (!v) return true;
    //   else if (v == "ADMIN") 
    //     return "User role is currently ADMIN";

    //   else return true;
    // },
    isEmailValidRule (v) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(v) || 'Invalid e-mail.'
    },
    async openMainDialog() {
      this.lookupItems = await eggApi.getUserAccounts();
      this.showMainDialog = true;
    },
    async saveItem() {
      let payload = {
        userPrincipalName: this.editedItem.userPrincipalName.toLowerCase(),
        contextName: this.editedItem.contextName.toUpperCase(),
        contextValue: this.editedItem.contextValue.join(',')
      };

      if (this.isAdd) {
        await eggApi.addAccount(payload);
      } else {
        await eggApi.updateAccount(payload);
      }
      this.lookupItems = await eggApi.getUserAccounts();
      this.closeChangeDialog();
    }
  }
}
</script>